module.exports = __webpack_public_path__ + "static/index/img/baikal-117.b4367a65.jpg";